import React from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import DataTable from "../../../../components/DataTable";
import { ALL_WORK_ORDER_LABORS_VIEW_QUERY } from "../../../../graphql/WorkOrders/WorkOrderLabors.graphql";
import { WORK_ORDER_LABOR_VIEW_COLUMNS } from "../columns";

function LaborHistory({ filters }) {
  const { id } = useParams();
  return (
    <React.Fragment>
      <DataTable
        columns={WORK_ORDER_LABOR_VIEW_COLUMNS}
        dataQuery={ALL_WORK_ORDER_LABORS_VIEW_QUERY}
        initialSortBy={[
          { id: "CompletedDate", desc: true },
          { id: "WONumber", desc: false },
          { id: "LineNo", desc: false }
        ]}
        name="VW_WorkOrderLabor"
        where={{ ...filters, VehicleRecIdRef: parseInt(id) }}
      />
    </React.Fragment>
  );
}
LaborHistory.propTypes = {
  filters: PropTypes.object
};
export default LaborHistory;
